import React, { useContext, useEffect, useState } from "react";
import classes from "./ConfigureHeader.module.css";
import {
  getCompanyFolderName,
  getUserFolderName,
  handleFileChange,
  isSuperUser,
} from "../Utility";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import axios1 from "axios";
import { Urls } from "../Urls";
import Loader from "../Components/Loader";
import { MyCompanyProfileContext } from "../MyCompanyProfileContext";
import { UserApiContext } from "../Components/UserDetailsContext/UserDetailsContext";
import { saveapi } from "../Components/CompanyProfileNew/Utility";
import { useIndentTracking } from "../Components/Indent/hooks/useIndentTracking";

const ConfigureHeader = ({
  setFormats,
  setFinalKeys,
  setSelectedIndex,
  setStep,
  setData,
  setFile,
  show,
  formats,
}) => {
  const [isUploading, setIsUploading] = useState(false);
  const [orgList, setOrgList] = useState([]);
  const { companySettingData, fetchCompanyProfileDetails } = useContext(
    MyCompanyProfileContext
  );
  const { companyProfile, users, userDetails } = useContext(UserApiContext);

  const {trackIndentEvent} = useIndentTracking()

  useEffect(()=> {
    trackIndentEvent("indent request", "user has viewed configure header section in indent module")
  },[])

  useEffect(() => {
    if (companySettingData && companySettingData.contact_information) {
      const result = isSuperUser(companySettingData.contact_information);
      if (result) {
        if (result.isOrgListPresent) {
          if (companySettingData && companySettingData.masters_setting) {
            if (
              companySettingData.masters_setting.masters_show_level &&
              companySettingData.masters_setting.masters_show_level ===
                "organization_level"
            ) {
              if (
                result.organizationList &&
                result.organizationList.length > 0
              ) {
                let finalList = [];
                let orgId = [];
                result.organizationList.map((item) => {
                  formats.map((format) => {
                    if (format.business_unit === item.name) {
                      finalList.push(format);
                      orgId.push(item.id);
                    }
                  });
                });
                let userLevelOrganizationList = [];
                finalList.map((orgs, index) => {
                  userLevelOrganizationList.push({
                    id: orgId[index],
                    name: orgs.business_unit,
                  });
                });
                setOrgList(result.organizationList);
              } else {
                setOrgList([{ name: "company", id: "company" }]);
              }
            } else {
              setOrgList([{ name: "company", id: "company" }]);
            }
          }
        } else {
          setOrgList([{ name: "company", id: "company" }]);
        }
      }
    }
  }, [companySettingData]);

  const addInput = () => {
    const newInput = {
      format_id: formats.length + 1,
      format_no: `INP-${formats.length + 1}`,
      file_url: "",
      business_unit: orgList.length > 0 ? orgList?.[0]?.name : "",
      uploaded_by:
        users && users.user_details && users.user_details.name
          ? users.user_details.name
          : userDetails.display_name
          ? userDetails.display_name
          : "",
      new: true,
    };
    setFormats([...formats, newInput]);
  };

  const inputChange = (value, type, index, operation) => {
    let finalFormats = [...formats];
    finalFormats[index][type] = value;
    setFormats(finalFormats);
  };

  const deleteInput = (index) => {
    let finalFormats = formats.map((format) => ({ ...format }));

    finalFormats.splice(index, 1);

    finalFormats = finalFormats.map((format, i) => ({
      ...format,
      format_id: i + 1,
    }));

    setFormats(finalFormats);
  };
  /**
   * Handles the file upload process for a new input.
   * This function is triggered by a file input change event. It processes the uploaded file,
   * reads its content using a `FileReader`, and parses the data using the `XLSX` library.
   * The function then updates the state with the uploaded file's name and the header data
   * from the file's first sheet.
   * @param {Event} e - The event object associated with the action that triggered this function.
   * @param {number} index - The index of the input to be uploaded.
   * @param {string} input - The name of input to be uploaded.
   * @returns {void} This function does not return a value.
   */
  const handleFileUpload = (e, index) => {
    if (!e.target.files[0].name.match(/\.(xlsx|xls)$/)) {
      toast.error("The file must be in .xlsx or .xls format.");
      return;
    }
    setIsUploading(true);
    if (e.target.files.length > 0) {
      setSelectedIndex(index);
      const file = e.target.files[0];
      handleFileChange(e, setFile, setData, setStep, true);
      uploadAttachments1(e, e.target.files, index);

      const fileReader = new FileReader();
      fileReader.onload = (event) => {
        const bufferArray = event.target.result;
        const workbook = XLSX.read(bufferArray, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        // const parsedData = XLSX.utils.sheet_to_json(sheet);
        const csvData = XLSX.utils.sheet_to_csv(sheet);
        const rows = csvData.split("\n");
      };
      fileReader.readAsArrayBuffer(file);
      // }
    }
  };

  /**
   * Uploads a list of attachments to file service and updates the file URLs in the object list.
   *
   * This function processes a list of files (attachments) provided and uploads files
   * to file service endpoint. It then updates URLs of the uploaded files in an object list
   * associated with a given input name.
   *
   * @param {FileList} attachments - A FileList object containing all the files the user has uploaded.
   * @param {string} input - The name of input to be uploaded.
   *
   * @returns {Promise<Object>} - Promise that resolves when all uploads are complete or rejects if any upload fails.
   *
   * TODO : move this function inside handleFileUpload function as this is a internal function
   */
  const uploadAttachments1 = (e, attachments, index) => {
    let userFiles = [];
    const timestamp = Date.now();
    for (let i = 0; i < attachments.length; i++) {
      userFiles.push({
        filePath: `procurements/company/${getCompanyFolderName()}/${getUserFolderName()}/${localStorage.getItem(
          "user_id"
        )}-${timestamp}-${attachments[i]["name"].replace(/ /g, "-")}`,
        fileName: `${attachments[i] - timestamp - ["name"]}`,
        fileData: attachments[i],
      });
    }
    return new Promise((resolve, reject) => {
      if (userFiles.length > 0) {
        userFiles.map((file) => {
          let body = {
            fileName: file["filePath"],
            accountName: "lnclientdata",
            containerName: "company-profile-uploads",
            action: "upload",
          };
          axios1
            .post(Urls.fileService, body)
            .then((response) => {
              let finalFormats = formats.map((f) => ({ ...f }));
              if (response?.data?.url) {
                finalFormats[index]["file_url"] = response.data.url;
                finalFormats[index]["header_map"] = {};
                let filename = e;
                finalFormats[index]["file_info"] = filename;
                setFormats(finalFormats);
              }
              axios1
                .put(response.data.url, file["fileData"], {
                  headers: {
                    "x-ms-blob-type": "blockblob",
                    "x-ms-blob-content-disposition": file["fileData"]["type"],
                  },
                })
                .then((res) => {
                  toast.success("File Uploaded Successfully!");
                  setIsUploading(false);
                })
                .catch((error) => {
                  toast.error("Error while uploading your attachments");
                  setIsUploading(false);
                  console.log(error);
                });
            })
            .catch((error) => {
              console.log(error);
              setIsUploading(false);
              reject({
                status: "failed",
                message: error,
              });
            });
        });
      } else {
        resolve({
          status: "success",
        });
      }
    });
  };

  /**
   * Handles the view action,
   * and updates the steps if input header data is present.
   * @param {Event} e - The event object associated with the action that triggered this function.
   * @param {number} index - The index of the input to be viewed.
   * @param {string} input - The name of input to be viewed.
   * @returns {void} This function does not return a value.
   */
  const handleView = (index) => {
    if (
      formats[index].file_url &&
      formats[index].file_url !== "" &&
      formats[index].new
    ) {
      setData([]);
      setSelectedIndex(index);
      setFinalKeys(formats[index].header_map);
      handleFileChange(
        formats[index].file_info,
        setFile,
        setData,
        setStep,
        true
      );
    } else if (formats[index].file_url && formats[index].file_url !== "") {
      setSelectedIndex(index);
      setFinalKeys(formats[index].header_map);
      setData(formats[index].all_keys);
      setStep(1);
    } else {
      toast.error("Please upload a file");
    }
  };
  const deleteFile = (index) => {
    const finalFormats = formats.slice();
    finalFormats[index]["file_url"] = "";
    setFormats(finalFormats);
  };

  const saveFormats = () => {
    let flag = true;
    if (formats && formats.length > 0) {
      let finalFormats = formats.map((f) => {
        let copy = { ...f };
        if (copy?.new) delete copy.new;
        return copy;
      });

      finalFormats.forEach((format) => {
        if (format.business_unit === "") {
          flag = false;
          toast.error("Business Unit cannot be empty!");
        } else if (format.file_url === "") {
          flag = false;
          toast.error("Please upload a file!");
        }
      });

      if (!flag) return false;
      setFormats(finalFormats);
      let updatedCompanyData = { ...companySettingData };
      updatedCompanyData.indent = {
        ...updatedCompanyData.indent,
        upload_formats: finalFormats,
      };

      let payload = { data: [updatedCompanyData] };

      saveapi(companyProfile?.domain_data?.company_id, updatedCompanyData)
        .then((resppp) => {
          fetchCompanyProfileDetails();
          toast.success("Details Updated Successfully!");
          trackIndentEvent("indent request", "user has clicked on save header formats for bulk indent upload")
        })
        .catch((err) => console.error(err));
    } else {
      toast.error("Please add at least one format!");
      return false;
    }
  };

  return (
    <div style={{ height: "65vh" }}>
      {show || isUploading ? (
        <Loader />
      ) : (
        <>
          <div className="d-flex justify-content-end mr-5 mb-3">
            <button className={classes.addInput} onClick={() => addInput()}>
              Add New Input
            </button>
          </div>
          <div>
            <div className={`d-flex justify-content-around ${classes.header}`}>
              <div>Sr. No.</div>
              <div>Format number</div>
              <div>Business Unit</div>
              {/* <div>Transportation Mode(s)</div> */}
              <div>File Name</div>
              <div>View</div>
              <div>Delete</div>
            </div>
            <div style={{ overflow: "auto", height: "45vh" }}>
              {formats &&
                formats.length > 0 &&
                formats.map((items, index) => {
                  return (
                    <div className="d-flex justify-content-around align-items-baseline my-2">
                      <div style={{ width: "39px", textAlign: "end" }}>
                        {index + 1}
                      </div>
                      <div style={{ width: "7vw", textAlign: "end" }}>
                        {items?.format_no}
                      </div>
                      <div
                        style={{
                          maxWidth: "max-content",
                          minWidth: "6vw",
                          marginLeft: "5%",
                          textAlign: "end",
                        }}
                      >
                        {items?.new !== true
                          ? items?.business_unit
                          : orgList &&
                            orgList.length !== 0 && (
                              <select
                                style={{
                                  width: "130%",
                                  fontSize: "13px",
                                  height: "40px",
                                }}
                                className="py-0 px-1"
                                placeholder="Select"
                                onChange={(e) => {
                                  inputChange(
                                    e.target.value,
                                    "business_unit",
                                    index,
                                    ""
                                  );
                                }}
                                value={items?.business_unit ?? ""}
                              >
                                <option hidden>Select</option>
                                {orgList &&
                                  orgList.length > 0 &&
                                  orgList.map((item) => {
                                    return (
                                      <option value={item.name}>
                                        {item.name}
                                      </option>
                                    );
                                  })}
                                {/* {fileNames.map((item, index) => (
                  <>
                    <option value={item}>{item}</option>
                  </>
                ))} */}
                              </select>
                              //   <select
                              //     name="business_unit"
                              //     id={`business_unit_${index}`}
                              // onChange={(e) => {
                              //   inputChange(
                              //     e.target.value,
                              //     "business_unit",
                              //     index,
                              //     ""
                              //   );
                              // }}
                              //     // value={items?.business_unit ?? ""}
                              //     // value={
                              //     //   orgList.some(
                              //     //     (org) => org.name === items.business_unit
                              //     //   )
                              //     //     ? items.business_unit
                              //     //     : "company"

                              //     // }
                              //     style={{
                              //       fontSize: "12px",
                              //       height: "30px",
                              //       width: "100%",
                              //       marginLeft: "1vw",
                              //     }}
                              //   >
                              //     {orgList &&
                              //       orgList.length > 0 &&
                              //       orgList.map((item) => {
                              //         return (
                              //           <option
                              //             value={item.id}
                              //             key={item.id}
                              //             data-id={item.id}
                              //           >
                              //             {item.name}
                              //           </option>
                              //         );
                              //       })}
                              //   </select>
                            )}
                      </div>
                      {/* <div style={{ width: "13vw", fontSize: "12px", textAlign: "center" }}>{items?.new !== true ? items.mode_of_transportation.join() :
                                            <Multiselect
                                                options={options}
                                                selectedValues={items?.mode_of_transportation
                                                    ? items.mode_of_transportation.map((item, index) => ({ name: item, id: index }))
                                                    : []}
                                                displayValue="name"
                                                onSelect={(value) => inputChange(value, "mode_of_transportation", index, "add")}
                                                onRemove={(value) => inputChange(value, "mode_of_transportation", index, "remove")}
                                            />}</div> */}
                      <div style={{ width: "119px", textAlign: "center" }}>
                        {items.file_url !== "" ? (
                          <div className="d-flex flex-column">
                            <div className="d-flex flex-row justify-content-center">
                              <button
                                className={`btn btn-sm btn-outline-secondary py-1 px-2 customBtn`}
                                onClick={() =>
                                  window.open(
                                    items.file_url.split("?")[0],
                                    "_parent"
                                  )
                                }
                              >
                                <i className="fa fa-download"></i>
                              </button>

                              <button
                                className={`btn btn-sm btn-outline-secondary py-0 px-2 customBtn`}
                                disabled={
                                  items.business_unit !== "company" &&
                                  !orgList.some(
                                    (org) => org.name === items.business_unit
                                  )
                                }
                                onClick={() => {
                                  if (
                                    orgList.some(
                                      (org) => org.name === items.business_unit
                                    ) ||
                                    items.business_unit === "company"
                                  ) {
                                    deleteFile(index);
                                  }
                                }}
                              >
                                <i className="fa fa-times"></i>
                              </button>
                            </div>
                            <div
                              style={{
                                fontSize: "12px",
                                wordWrap: "break-word",
                              }}
                            >
                              {items?.file_info?.target
                                ? items.file_info.target.value
                                    .split("\\")
                                    .pop()
                                    .split("-")
                                    .pop()
                                : items?.file_info?.name}
                            </div>
                          </div>
                        ) : (
                          <div
                            style={{ width: "119px" }}
                            className="d-flex justify-content-center"
                          >
                            <button
                              onClick={(e) =>
                                document
                                  .getElementById(`upload-file-btn${index}`)
                                  .click()
                              }
                              className={`btn btn-sm btn-outline-secondary py-1 px-2 customBtn`}
                            >
                              <i
                                style={{
                                  cursor: "pointer",
                                  // marginLeft: "0.25rem",
                                  fontSize: "medium",
                                }}
                                className="fa fa-upload"
                              ></i>
                            </button>
                          </div>
                        )}
                        <input
                          type="file"
                          id={`upload-file-btn${index}`}
                          style={{ display: "none" }}
                          onChange={(e) => handleFileUpload(e, index)}
                        />
                      </div>
                      <div
                        style={{
                          cursor: "pointer",
                          color: "#393185",
                          fontWeight: "bold",
                          textDecoration: "underline",
                          width: "56px",
                        }}
                        onClick={(e) => handleView(index)}
                      >
                        view
                      </div>
                      <div style={{ width: "54px" }}>
                        <button
                          onClick={() => deleteInput(index)}
                          className={`btn btn-sm btn-primary`}
                          disabled={
                            !orgList.some(
                              (org) => org.name === items.business_unit
                            )
                          }
                        >
                          <i className="fa fa-trash" />
                        </button>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="d-flex justify-content-center w-100 py-3">
              <button
                className="btn btn-sm btn-success mx-5"
                onClick={() => saveFormats()}
              >
                Save
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ConfigureHeader;
